import {
  Grid,
  InputLabel,
  ToggleButton,
  ToggleButtonGroup
} from '@mui/material';

import useCloudSourceForm from '../../CloudSourceHooks/useCloudSourceForm.hooks';
import { SourceDialogMode } from '../../SourceCreate.types';
import { shouldShowAuthenticationMode } from '../authenticationVisibility.utils';
import CertificateModeSelector from './CertificateModeSelector';

/**
 * Authentication mode selector component.
 * Allows users to choose between Client Secret and Certificate authentication.
 * Only shown for certificate-based services.
 * Disabled in Edit mode to prevent authentication method changes after creation.
 */
const AuthModeSelector = () => {
  const {
    mode,
    connectionInputSchema,
    authenticationMode,
    handleAuthenticationModeChange
  } = useCloudSourceForm();

  if (!shouldShowAuthenticationMode(connectionInputSchema)) {
    return null;
  }

  return (
    <>
      <Grid size={{ xs: 12, sm: 6, md: 4 }}>
        <InputLabel htmlFor="device-name-input">Choose Auth Mode</InputLabel>
        <ToggleButtonGroup
          size="small"
          color="primary"
          value={authenticationMode}
          exclusive
          onChange={handleAuthenticationModeChange}
          aria-label="Platform"
          disabled={mode === SourceDialogMode.Edit}
        >
          <ToggleButton value="client_secret" key="client_secret">
            Client Secret
          </ToggleButton>
          <ToggleButton value="certificate" key="certificate">
            Certificate
          </ToggleButton>
        </ToggleButtonGroup>
      </Grid>
      <CertificateModeSelector />
    </>
  );
};

export default AuthModeSelector;
